/**
 * hooks de listagem e criacao de pesquisas.
 * cursor pagination via next_cursor retornado pela api.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  PesquisaCreate,
  PesquisaDetail,
  PesquisaListResponse,
  StatusPesquisaT,
} from '@licita-mind/shared-types';
import { apiFetch } from '../lib/api';

export interface PesquisasListParams {
  readonly status?: StatusPesquisaT;
  readonly limit?: number;
  readonly cursor?: string | null;
}

const buildQs = (params: PesquisasListParams): string => {
  const sp = new URLSearchParams();
  if (params.status) sp.set('status', params.status);
  if (params.limit) sp.set('limit', String(params.limit));
  if (params.cursor) sp.set('cursor', params.cursor);
  const s = sp.toString();
  return s ? `?${s}` : '';
};

export const useListPesquisas = (params: PesquisasListParams = {}) =>
  useQuery({
    queryKey: ['pesquisas', params],
    queryFn: () => apiFetch<PesquisaListResponse>(`/v1/pesquisas${buildQs(params)}`),
    staleTime: 15_000,
  });

export const useCreatePesquisa = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PesquisaCreate) =>
      apiFetch<PesquisaDetail>('/v1/pesquisas', { method: 'POST', body: input }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['pesquisas'] });
    },
  });
};
